// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBApUeFUbJlInWIWdXho4DK-lgYKE2AhkE',
  appId: '1:808648763959:web:0cf20afb11ac405831edb2',
  authDomain: 'edhrec-1563844611919.firebaseapp.com',
  databaseURL: 'https://edhrec-1563844611919.firebaseio.com',
  messagingSenderId: '808648763959',
  projectId: 'edhrec-1563844611919',
  storageBucket: 'edhrec-1563844611919.appspot.com',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const firestore = initializeFirestore(app, {})

export default app
